import * as wizardLaunchType from '../../constants/ActionTypes';
import {
  resetDynamicData,
  setDynamicData,
  updateFormState,
  setCurrentStep,
  setDirectAccessData,
  setDirectAccessLoading,
  setDirectAccessError,
} from '../reducers/WizardLaunchReducers';

// Action Creators
export const nextStep = () => ({
  type: 'NEXT_STEP',
});

export const prevStep = () => ({
  type: 'PREV_STEP',
});

export const resetStep = () => ({
  type: 'RESET_STEP',
});

export const setCourseDetails = (details) => ({
  type: wizardLaunchType.SET_COURSE_DETAILS,
  payload: details,
});

export const fetchDynamicDataRequest = (wizardData) => ({
  type: wizardLaunchType.FETCH_DYNAMIC_DATA_REQUEST,
  payload: wizardData,
});

export const fetchDynamicDataSuccess = (data) => ({
  type: wizardLaunchType.FETCH_DYNAMIC_DATA_SUCCESS,
  payload: data,
});

export const fetchDynamicDataFailure = (error) => ({
  type: wizardLaunchType.FETCH_DYNAMIC_DATA_FAILURE,
  payload: error,
});

export const setCdlType = (cdlType) => ({
  type: wizardLaunchType.SET_CDL_TYPE,
  payload: cdlType,
});

export const setEndorsements = (endorsements) => ({
  type: wizardLaunchType.SET_ENDORSEMENTS,
  payload: endorsements,
});

export const setDirectCourses = (directCourses) => ({
  type: wizardLaunchType.SET_DIRECT_COURSES,
  payload: directCourses,
});

export const setStateSelection = (stateSelection) => ({
  type: wizardLaunchType.SET_STATE_SELECTION,
  payload: stateSelection,
});

export const setVideoSelection = (selection) => ({
  type: wizardLaunchType.SET_VIDEO_SELECTION,
  payload: selection,
});

export const setCourseRecommendation = (recommendation) => ({
  type: wizardLaunchType.SET_COURSE_RECOMMENDATION,
  payload: recommendation,
});

// New action to remove endorsement
export const removeEndorsement = (endorsementIndex) => ({
  type: wizardLaunchType.REMOVE_ENDORSEMENT,
  payload: endorsementIndex,
});

// New actions for courses
export const setSelectedCourses = (courses) => ({
  type: wizardLaunchType.SET_SELECTED_COURSES,
  payload: courses,
});

export const removeSelectedCourse = (courseIndex) => ({
  type: wizardLaunchType.REMOVE_SELECTED_COURSE,
  payload: courseIndex,
});

export const removeDirectCourse = (courseIndex) => ({
  type: wizardLaunchType.REMOVE_DIRECT_COURSE,
  payload: courseIndex,
});

// These actions are now imported from the slice
export { resetDynamicData, setDynamicData, updateFormState, setCurrentStep };

// Add these new action creators
export const setNavigationHistory = (history) => ({
  type: 'SET_NAVIGATION_HISTORY',
  payload: Array.isArray(history) ? history : [],
});

export const addToNavigationHistory = (path) => ({
  type: 'ADD_TO_NAVIGATION_HISTORY',
  payload: path,
});

export const updateNavigationState = (
  navigationPath,
  currentStep,
  previousStep
) => ({
  type: 'UPDATE_NAVIGATION_STATE',
  payload: { navigationPath, currentStep, previousStep },
});

export const removeLastFromHistory = () => ({
  type: 'REMOVE_LAST_FROM_HISTORY',
});

export const setManualBackNavigation = (isManualBack) => ({
  type: 'SET_MANUAL_BACK_NAVIGATION',
  payload: isManualBack,
});

export const setPreviousStep = (step) => ({
  type: 'SET_PREVIOUS_STEP',
  payload: step,
});
export const setSteps = (steps) => ({
  type: wizardLaunchType.SET_STEPS,
  payload: steps,
});

// Add these action creators
export const clearEndorsements = () => ({
  type: wizardLaunchType.CLEAR_ENDORSEMENTS,
});

export const clearMoreClassSelection = () => ({
  type: wizardLaunchType.CLEAR_MORE_CLASS_SELECTION,
});

export const setQueryParams = (params) => ({
  type: wizardLaunchType.SET_QUERY_PARAMS,
  payload: params,
});

// Export the constant to be used directly
export const { SET_QUERY_PARAMS } = wizardLaunchType;

// Direct Access Actions
export const fetchDirectAccessRequest = (accessParams) => ({
  type: 'FETCH_DIRECT_ACCESS_REQUEST',
  payload: accessParams
});

export const fetchDirectAccessDataSuccess = (data) => ({
  type: 'SET_DIRECT_ACCESS_DATA_SUCCESS',
  payload: data
});

export const fetchDirectAccessLoading = (loading) => ({
  type: 'SET_DIRECT_ACCESS_LOADING',
  payload: loading
});

export const fetchDirectAccessError = (error) => ({
  type: 'SET_DIRECT_ACCESS_ERROR',
  payload: error
});

// Add a cancellation action for direct access requests
export const cancelDirectAccessRequest = () => ({
  type: 'CANCEL_DIRECT_ACCESS_REQUEST'
});
